"use strict";

var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var bunsen = require('bunsen/libraries/bunsen');
var SolrCollection = require('bunsen/collections/SolrCollection');
var fetchDiscrete = require('bunsen/helpers/fetchDiscrete');
var Items = module.exports = bunsen.Items = SolrCollection.extend({}, fetchDiscrete);
var Item = require('bunsen/models/inventory/Item');
var Clump = require('bunsen/libraries/clump');
var verticals = require('dibs-vertical-helpers');
var endpoints = require('dibs-endpoints');
var ConversionCalculation = require('bunsen/models/ecomm/ConversionCalculation');
var CurrencyConversion = require('bunsen/models/ecomm/CurrencyConversion');

// bunsen.Items
var solrItemsURI = endpoints.solrItems();
_.extend(Items.prototype, {

    model: Item, // bunsen.Item,

    url: function () {
        if (!this._discreteIds) {
            return solrItemsURI;
        }
        return solrItemsURI + 's?' + $.param({itemId : this._discreteIds.join(',')});
    },

    initialize: function () {
        this.resetParams();
        return this;
    },

    parse: function (data) {
        var keys;
        data = SolrCollection.prototype.parse.call(this, data);
        // strip out toplevel key. e.g. FurnitureItem, FashionItem
        _.each(data, function (item, index) {
            keys = _.keys(item);
            if (keys.length === 1) {
                item = item[keys[0]];
                data[index] = item;
                // TODO : Here we add the api type (ie. "futnitureItem" or "fashionItem" as the apiType property to item JSON.
                // TODO : This is a work-around for the SOLR inventory endpoint not returning the correct apiType
                // TODO : Please remove this temporary work-around in the future as per GOODS-1139
                if (_.isUndefined(data[index].apiType)) {
                    data[index].apiType = keys[0];
                }
            }
        });
        return data;
    },

    /**
     * Saves all items in the collection
     * @param options - jquery options
     * @param saveFunction - optional.  This is part of the vertical retry hack, otherwise it should be removed
     * @returns {*}
     */
    saveAll: function (options, saveFunction) {
        var promise = $.Deferred();
        var clump = new Clump();
        var failedItems = new Items();
        var retryVerticals = new RegExp(verticals.VERTICAL_JEWELRY + '|' + verticals.VERTICAL_FASHION);
        this.each(function (item) {
            var save = saveFunction || item.save;
            save.call(item, null, $.extend({ clump: clump }, options)).fail(function (jqXHR) {
                if (jqXHR.status === 500 && retryVerticals.test(item.get('vertical'))) {
                    failedItems.add(item);
                }
            });
        });

        this._saveAllVerticalHack(clump, failedItems, promise, options, saveFunction);

        return promise;
    },

    /**
     * TODO !!!!!!!!!! Delete the following function all of it's uses once the BE team fixes verticals in SOLR inventory
     * TODO !!!!!!!!!! This code was placed here as a temporary work-around and must be removed as per ticket :
     * https://1stdibs.atlassian.net/browse/GOODS-806
     */
    _saveAllVerticalHack: function (clump, failedItems, promise, options, saveFunction) {
        clump.run({ mode: 'SYNC_PARALLEL' }).then(function (jXHR) {
            var clump;
            if (failedItems.length) {
                clump = new Clump();
                failedItems.each(function (model) {
                    var prevVertical = model.get('vertical');
                    var save = saveFunction || model.save;
                    model.set('vertical', prevVertical === verticals.VERTICAL_FASHION ? verticals.VERTICAL_JEWELRY : verticals.VERTICAL_FASHION);
                    model.set('apiType', model.get('vertical') + 'Item');
                    save.call(model, null, $.extend({ clump: clump }, options));
                    model.set('vertical', prevVertical);
                    model.set('apiType', prevVertical + 'Item');
                });
                clump.run({ mode: 'SYNC_PARALLEL' }).then(function (jXHR) {
                    promise.resolve(jXHR);
                }).fail(function (jXHR) {
                    promise.reject(jXHR);
                });
            }
            else {
                promise.resolve(jXHR);
            }
        }).fail(function (jXHR) {
            promise.reject(jXHR);
        });
    },

    saveAllItemsWithPublishOptions: function (publishOptions, options) {
        this.each(function (item) {
            item.setPublishingOptions(publishOptions);
        });
        return this.saveAll($.extend({patch: true}, options));
    },

    convertToUsd: function () {
        var self = this;
        var dfd = new $.Deferred();
        var conversions = [];
        var calculation = new ConversionCalculation(); // bunsen.ConversionCalculation();

        // find items that need to be converted
        self.each(function (item) {
            if (item.getCurrency() !== 'USD' && !item.hidePrice()) {
                conversions.push(new CurrencyConversion({
                    label: item.get('id'),
                    fromCurrency: item.getCurrency(),
                    toCurrency: 'USD',
                    fromAmount: item.getPrice(),
                    toAmount: null
                }));
            }
        });

        // run conversions
        if (conversions.length) {
            calculation.set('conversions', conversions);
            calculation.save().then(function () {

                // update items
                calculation.get('conversions').each(function (conversion) {
                    var item = self.get(conversion.get('label'));
                    item.get('pricing').currency = conversion.get('toCurrency');
                    item.get('pricing').amount = conversion.get('toAmount');
                });
                dfd.resolve();

                // currency conversion failed
            }, function () {
                dfd.reject();
            });

            // no conversions to run, all prices in usd or empty collection
        } else {
            dfd.resolve();
        }

        return dfd.promise();
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/inventory/Items.js
// module id = 129
// module chunks = 62